const Config = (networkId) => {
  let etherscan = {
    url: 'https://etherscan.io/',
  }
  if (String(networkId) === '4') {
    etherscan.url = 'https://rinkeby.etherscan.io/'
  } else if (String(networkId) === '42') {
    etherscan.url = 'https://kovan.etherscan.io/'
  } else if (String(networkId) === '97') {
    etherscan.url = 'https://testnet.bscscan.com/'
  } else if (String(networkId) === '56') {
    etherscan.url = 'https://bscscan.com/'
  }
  etherscan.getAddressUrl = (address) => etherscan.url + 'address/' + address
  etherscan.getTokenUrl = (address) => etherscan.url + 'token/' + address
  etherscan.getTranUrl = (hash) => etherscan.url + 'tx/' + hash

  let share = {
    geCheckEscrowUrl: (escrowId) => {
      const url = new URL(document.location.href.replace(document.location.search, "").replace(document.location.pathname, ""))
      url.pathname = "checkEscrow"
      url.searchParams.set("EscrowId", escrowId)
      return url.href
    }
  }
  return {
    etherscan,
    share
  }
}
export default Config
